import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getUserInfo } from '../../redux/selectors'
import { fetchContact, updateContact, saveSubscription, saveEmail, saveDeactivate, confirmProfile } from '../../redux/actions'
import ContactComponent from './ContactComponent'
import { isEmpty, cloneDeep } from 'lodash'
import { requesterEmailAddress } from '../../libs/utils'
import ConfirmProfileDialogComponent from './ConfirmProfileDialogComponent'

class ConfirmProfileContainer extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      profileInfoChanged: false,
      contact: this.props.contact,
      originalContact: null,
      dialogOpen: true,
      updates: {
        emailAddress: requesterEmailAddress(this.props)
      }
    }

    this.confirmProfile = () => {
      this.props.confirmProfile(this.state.contact, this.state.profileInfoChanged)
    }

    this.requestEmailEdit = (oldEmail, newEmail) => {
      const emailAddress = requesterEmailAddress(this.props)
      this.props.saveEmail({emailAddress, newEmailAddress: newEmail})
    }

    this.updateContact = event => {
      const field = event.target && event.target.id
      const value = event.target && event.target.value
      if (!field) return
      this.props.updateContact({
        ...this.state.contact,
        [field]: value
      })
      this.setState(prevState => ({profileInfoChanged: prevState.profileInfoChanged || prevState.originalContact[field] !== value}))
    }

    this.setContactToDefault = () => {
      this.props.updateContact(cloneDeep(this.state.originalContact))
      this.setState(prevState => ({profileInfoChanged: false}))
    }

    this.handleCloseDialog = () => this.setState({dialogOpen: false})
  }

  componentDidMount () {
    document.title = 'Confirm Profile'
    const emailAddress = requesterEmailAddress(this.props)
    this.props.fetchContact(emailAddress)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!isEmpty(nextProps.contact) && isEmpty(prevState.originalContact)) {
      return {
        contact: nextProps.contact,
        originalContact: cloneDeep(nextProps.contact)
      }
    }
    return {
      contact: nextProps.contact,
      originalContact: prevState.originalContact
    }
  }

  render () {
    const { contact, dialogOpen } = this.state
    if (isEmpty(contact)) return null

    return (
      <React.Fragment>
        <ContactComponent
          contact={contact}
          editing
          saveContact={this.confirmProfile}
          updateContact={this.updateContact}
          resetContact={this.setContactToDefault}
          requestEmailEdit={this.requestEmailEdit}
          profileInfoChanged // to trigger save button
        />
        <ConfirmProfileDialogComponent dialogOpen={dialogOpen} handleCloseDialog={this.handleCloseDialog} />
      </React.Fragment>
    )
  }
}

ConfirmProfileContainer.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  contact: PropTypes.object
}

const mapStateToProps = state => ({
  emailAddress: getUserInfo(state).emailAddress,
  contact: getUserInfo(state).contact
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchContact,
    updateContact,
    saveSubscription,
    saveDeactivate,
    saveEmail,
    confirmProfile
  }, dispatch)
)

const ConfirmProfileConnect = connect(mapStateToProps, mapDispatchToProps)(ConfirmProfileContainer)

export default ConfirmProfileConnect
